import React, { useState } from 'react';
import Compiler from '../compiler/Compiler';
import KovReference from './KovReference';

const KovReferenceGroup = ({ item, color }) => {
  throw new Error('This component is not refactored yet');
  // TO-DO: fix kovReference first
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="kov-reference-group example-ref">
      <a
        className={`kov-pro-btn kov-pro-btn--sm kov-pro-btn--inverted kov-pro-btn--light ${
          !isOpen ? 'collapsed' : ''
        }`}
        data-toggle="collapse"
        role="button"
        aria-expanded="true"
        aria-controls="example-ref-db"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>
          <Compiler text={item.title} />
        </span>
        <span className="kov-pro-btn__icon--right">
          <i className="icon-kov-pro-down-arrow"></i>
        </span>
      </a>

      {isOpen && (
        <div className="example-ref-db collapse show" id="example-ref-db-1">
          {(item?.items || item?.children)?.map((reference, i) => (
            <KovReference key={i} item={reference} color={color} />
          ))}
        </div>
      )}
    </div>
  );
};

export default KovReferenceGroup;
